/*
  IN-APP NOTIFICATION ACTIONS
 */

export const CREATE_IN_APP_NOTIFICATION = "CREATE_IN_APP_NOTIFICATION";
export const DELETE_IN_APP_NOTIFICATION = "DELETE_IN_APP_NOTIFICATION";
